import { useRollbar } from '@rollbar/react'
import { useReduxLogging } from 'client/store'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { resetReduxLogData } from 'src/editor/store/redux-logging/redux-logging-actions'
import {
  getReduxLogs,
  getReduxLogsData,
} from 'src/editor/store/redux-logging/redux-logging-selectors'

export const useSentReduxLogsToRollbar = () => {
  const rollbar = useRollbar()
  const dispatch = useDispatch()
  const reduxLogging = useReduxLogging(getReduxLogsData)
  const reduxLogs = useReduxLogging(getReduxLogs)

  useEffect(() => {
    reduxLogging.forEach(
      ({ shouldBeSentToRollbar, message, resetReduxLogPayload }) => {
        if (shouldBeSentToRollbar) {
          rollbar.error(message, { logs: reduxLogs })
          dispatch(resetReduxLogData(resetReduxLogPayload))
        }
      },
    )
  }, [reduxLogging, rollbar, dispatch, reduxLogs])
}
